import React from 'react';
import Footer from '../components/Footer';
import '../App.css';

export default function Projects() {
  return (
    <>
      <h1 className='projects'>Projects</h1>
      <div className='filler'>
        <ul className='projects-ul'>
          <li className='projects-li'>My first project was King's Path, a platform puzzle game.</li>
          <li className='projects-li'>My second project was A Good Alien, a platform multiplayer game.</li>
          <li className='projects-li'>My third project, and first to be released, is Balloons Odyssey.</li>
        </ul>
      </div>
      <Footer />
    </>
  );
}